import { Store } from '@ngxs/store';
import { DriveState } from '../state/drive-state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
var DriveContextActions = /** @class */ (function () {
    function DriveContextActions(store) {
        this.store = store;
    }
    DriveContextActions.prototype.getActions = function () {
        this.updateStatus();
        return this.actions;
    };
    DriveContextActions.prototype.getSelectedEntries = function () {
        return this.store.selectSnapshot(DriveState.selectedEntries);
    };
    DriveContextActions.prototype.updateStatus = function () {
        this.multipleEntriesSelected = this.store.selectSnapshot(DriveState.multipleEntriesSelected);
        this.allStarred = this.store.selectSnapshot(DriveState.allSelectedEntriesStarred);
        this.onlyFoldersSelected = this.store.selectSnapshot(DriveState.onlyFoldersSelected);
    };
    DriveContextActions.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DriveContextActions_Factory() { return new DriveContextActions(i0.ɵɵinject(i1.Store)); }, token: DriveContextActions, providedIn: "root" });
    return DriveContextActions;
}());
export { DriveContextActions };
